import {get, map, size, find} from 'lodash';
import moment from 'moment-timezone';
import BaseService from '../../middleware/BaseService';
import SubscriptionTypes from '../SubscriptionTypes';

const DVR_LIST_ENDPOINT = '/dvr/list';
const DVR_TOTAL_AMOUNT_ENDPOINT = '/dvr/total';
const HEALTH_REPORT_ENDPOINT = '/dvr/list/report';
const DVR_UNPAIR_ENDPOINT = `/dvr/{serialId}/unlink/offline`;
const NOTIFICATION_SUBSCRIPTION_ENDPOINT = '/alerts/subscription';


class DVRHealthService extends BaseService {
  prefix = DVR_LIST_ENDPOINT;

  async getValidSubscriptions() {
    const resp = await this.getAllCurrentSubscriptions();
    return resp.filter(subs => SubscriptionTypes.get(get(subs, '_source.type', '')));
  }

  async loadDVRs(page, filters = {}) {
    const params = {
      size: 30,
      page,
      ...this.buildParams(filters)
    };

    const response = await this.search(params);
    const payload = {
      page,
      pages: get(response, 'meta.paging.pages', 0),
      dvrs: map(get(response, 'data', []))
    };

    return payload;
  }

  async loadTotalDVRs(filters = {}) {
    const params = this.buildParams(filters);

    const response = await this.search(params, DVR_TOTAL_AMOUNT_ENDPOINT);
    const payload = {totalDvrs: get(response, 'data', 0)};

    return payload;
  }

  buildParams(filters) {
    const {groups, chips, ...otherFilters} = filters;
    const params = {...otherFilters};

    if (size(groups) > 0) {
      params.groups = JSON.stringify(groups);
    }

    if (size(chips) > 0) {
      const vehicleNumber = get(find(chips, it => it.name === 'vehicle'), 'label', null);
      if (vehicleNumber) {
        params.vehicleNumber = vehicleNumber;
      }
      const serialNumber = get(find(chips, it => it.name === 'dvr'), 'label', null);
      if (serialNumber) {
        params.serialNumber = serialNumber;
      }
    }

    return params;
  }

  async getReportURL(filters = {}) {
    const {
      groups,
      chips,
      pairingMethod,
      ...otherFilters
    } = filters;

    const params = {
      timezone: moment.tz.guess(),
      pairingMethod,
      ...otherFilters,
      language: localStorage.getItem('language')
    };

    if (size(groups) > 0) {
      params.groups = JSON.stringify(groups);
    }
    if (size(chips) > 0) {
      params.vehicle = get(find(chips, it => it.name === 'vehicle'), 'label');
      params.serial = get(find(chips, it => it.name === 'dvr'), 'label');
    }

    const response = await this.search(params, HEALTH_REPORT_ENDPOINT, {headers: {'Content-Type': 'application/octet-stream'}});

    const payload = {
      reportFile: response
    };

    return payload;
  }

  async unpairDvrOffline(serialNo) {
    return await this.post({}, DVR_UNPAIR_ENDPOINT.replace('{serialId}', serialNo));
  }

  async getCurrentSubscription() {
    const data = await this.getValidSubscriptions();

    if (data.length <= 0) {
      return SubscriptionTypes.NOT_SUBSCRIBED;
    }

    if (data.length > 1) {
      return SubscriptionTypes.REAL_TIME_AND_DAILY;
    }

    return SubscriptionTypes.get(data[0]._source.type);
  }

  async subscribeForUpdates(subscription) {
    await this.unsubscribeForUpdates();

    const subscriptionConfig = {
      method: {
        type: 'EMAIL',
        value: subscription.email
      },
      type: subscription.subscriptionType.type
    };

    await this.post(subscriptionConfig, NOTIFICATION_SUBSCRIPTION_ENDPOINT);

    return subscription.subscriptionType;
  }

  async unsubscribeForUpdates() {
    const data = await this.getValidSubscriptions();

    if (data.length <= 0) {
      return SubscriptionTypes.NOT_SUBSCRIBED;
    }

    const ids = data.map(subscription => subscription._source.id);

    await this.api.remove(NOTIFICATION_SUBSCRIPTION_ENDPOINT, {
      id: ids.join(',')
    });

    return SubscriptionTypes.NOT_SUBSCRIBED;
  }

  async getAllCurrentSubscriptions() {
    const response = await this.search(null, NOTIFICATION_SUBSCRIPTION_ENDPOINT);
    return get(response, 'data', []);
  }
}

export default new DVRHealthService();
